(() => {
  const script = document.currentScript;
  const zoomLabelTemplate = script?.dataset.zoomLabel || 'Zoom media __INDEX__';
  const zoomableSlideSelector =
    'slideshow-slide.product-media-container--zoomable[on\\:click]';

  const enhanceGallery = (root = document) => {
    const slides = root.matches?.(zoomableSlideSelector)
      ? [root]
      : [...root.querySelectorAll?.(zoomableSlideSelector) || []];

    slides.forEach((slide) => {
      const gallery = slide.closest('media-gallery');
      const gallerySlides = gallery
        ? [...gallery.querySelectorAll(zoomableSlideSelector)]
        : slides;
      const index = Math.max(0, gallerySlides.indexOf(slide)) + 1;

      slide.setAttribute('role', 'button');
      syncTabIndex(slide);
      slide.setAttribute('aria-label', zoomLabelTemplate.replace('__INDEX__', String(index)));
    });
  };

  // §390：Horizon は画面外の写真に aria-hidden="true" を付ける。読み上げから隠した写真に Tab で止まらないよう、
  // aria-hidden に合わせて tabindex を 0／-1 に切り替える（違う時だけ書く＝見張りが自分の書き込みで回り続けない）
  function syncTabIndex(slide) {
    const next = slide.getAttribute('aria-hidden') === 'true' ? -1 : 0;
    if (slide.tabIndex !== next) slide.tabIndex = next;
  }

  enhanceGallery();

  document.addEventListener('shopify:section:load', (event) => enhanceGallery(event.target));

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) enhanceGallery(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.target instanceof HTMLElement && record.target.matches(zoomableSlideSelector)) syncTabIndex(record.target);
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

    const slide = event.target instanceof Element ? event.target.closest(zoomableSlideSelector) : null;
    if (!(slide instanceof HTMLElement) || event.target !== slide || event.repeat) return;

    event.preventDefault();
    slide.click();
  });
})();
